import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Input, Button, theme, Grid, Spin, Flex } from 'antd';
import _ from 'lodash';

import config from '../../config';
import AuthHelper from '../../helpers/auth';
import GeneralHelper from '../../helpers/general';
import sengLogo from '../../images/seng-logo.svg';
import background from '../../images/auth-background.webp';

const { Text, Link } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

const LoginPage = (props) => {
	const { token } = useToken();
	const screens = useBreakpoint();
	const history = useHistory();
	const query = GeneralHelper.getParamsFromUrl();
	const { requestAuthOtp, resetPage, resetMeta, loginPageProps, getPublishedEvent } = props;
	const { loadingRequestSubmit, meta, loading, event } = loginPageProps;

	// States
	const [disabled, setDisabled] = useState(true);
	const [email, setEmail] = useState('');
	const [emailErrMsg, setEmailErrMsg] = useState(null);


	// Functions
	const handleRequestAuthOtp = () => {
		requestAuthOtp({
			email,
			query
		});
	};

	useEffect(() => {
		// Check if already logged in
		const authenticated =  AuthHelper.isAuthenticated();
		if (authenticated) {
			history.push('/application');
		}

		// Get event
		getPublishedEvent();

		return () => {
			resetPage();
			resetMeta();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (email === '' || GeneralHelper.isEmailValid(email)) {
			setEmailErrMsg(null);
		}

		if (email.length > 4 && !GeneralHelper.isEmailValid(email)) {
			setEmailErrMsg('Invalid email');
		}

		if (
			!_.isEmpty(email) &&
			GeneralHelper.isEmailValid(email)
		) {
			setDisabled(false);
		} else {
			setDisabled(true);
		}
	}, [email]);

	useEffect(() => {
		if (meta && meta.code !== 200) {
			const message = meta.message;
			setEmailErrMsg(message);
		}

		return () => {
			setTimeout(() => {
				setEmailErrMsg(null);
				resetMeta();
			}, 5000);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	// Fix for loading background image
	if (loading || !event) {
		return (
			<Flex
				justify="center"
				align="center"
				style={{ height: '100vh' }}
			>
				<Spin/>
			</Flex>
		);
	}

	return (
		<div
			style={{
				background: `url(${_.get(event, 'image_asset_id') ?
					`${config.api}/public/assets/events/published` : background})`,
				backgroundSize: 'cover',
				height: '100vh'
			}}
		>
			<div
				style={{
					height: screens.xs ? '80vh' : '100vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				<Flex
					vertical
					style={{
						width: 535,
						backgroundColor: token.whiteColor,
						borderRadius: 20,
						padding: '41px 39px',
						boxShadow: '0px 4px 4px 0px #00000026'
					}}
				>
					<Flex
						justify="center"
						style={{ alignSelf: 'center', maxHeight: 56, marginBottom: 30 }}
					>
						<img
							src={sengLogo}
							alt="seng-logo"
							style={screens.xs ? { width: '100%' } : { height: '100%' }}
						/>
					</Flex>
					<Text
						style={{
							fontSize: 32,
							color: token.colorPrimary,
							fontWeight: 110,
							lineHeight: 1
						}}
					>
						{event ? event.name : 'HKUST Engineering Summer Camp Online Application System'}
					</Text>
					<div style={{ marginTop: 25, marginBottom: 25 }}>
						<Text
							strong
							style={{ color: token.colorPrimary, fontSize: 19 }}
						>
							Email Address
						</Text>
						<Input
							placeholder="Enter Email Address"
							size="large"
							value={email}
							onChange={e => setEmail(e.target.value)}
							onPressEnter={handleRequestAuthOtp}
							style={{ marginTop: 8, height: 48 }}
						/>
						{emailErrMsg && <Text type="danger">{emailErrMsg}</Text>}
					</div>
					<div>
						<Button
							type="primary"
							size="large"
							disabled={disabled}
							loading={loadingRequestSubmit}
							style={{ width: '100%', borderRadius: 50, height: 56 }}
							onClick={handleRequestAuthOtp}
						>
							Get Code
						</Button>
						<div style={{ marginTop: 12 }}>
							<Text style={{ fontSize: 16 }}>Don’t have an account yet?</Text>
							<Link
								onClick={() => history.push('/create')}
								style={{ marginLeft: 5, fontSize: 16 }}
							>
								Create account
							</Link>
						</div>
					</div>
				</Flex>
			</div>
		</div>
	);
};

export default LoginPage;